// extracted by mini-css-extract-plugin
export var imageFitCrop = "ImgixImage-module--image-fit-crop--5d1f7";
export var imageFitOriginal = "ImgixImage-module--image-fit-original--ad4d5";